export default {
  phases: [],
  disciplines: [],
  memberRoles: []
};
